import {
  getPlanCourseList,
  getSubjectList,
  getUserList,
  getPlanList,
  addPlan,
  updatePlan,
  deletePlan,
  addCourse
} from '@/api/plan';

const plan = {
  namespaced: true,
  state: {
    planIsLoading: false,
    addPlanFlag: false,
    attendancePlanList: [],
    planMainContentTitle: [
      { id: 1, name: '时间' },
      { id: 2, name: '星期一' },
      { id: 3, name: '星期二' },
      { id: 4, name: '星期三' },
      { id: 5, name: '星期四' },
      { id: 6, name: '星期五' },
      { id: 7, name: '星期六' },
      { id: 8, name: '星期日' }
    ],
    planMainContentList: [],
    subjectList: [],
    teacherList: [],
    editClassList: [] // 编辑作息时，备份使用范围
  },
  mutations: {
    SET_EDIT_CLASS_LIST: (state, editClassList) => {
      state.editClassList = editClassList;
    },
    SET_PLAN_IS_LOADING: (state, planIsLoading) => {
      state.planIsLoading = planIsLoading;
    },
    SET_ADD_PLAN_FLAG: (state, addPlanFlag) => {
      state.addPlanFlag = addPlanFlag;
    },
    SET_PLAN_MAIN_CONTENT_LIST: (state, planMainContentList) => {
      state.planMainContentList = planMainContentList;
    },
    SET_ATTENDANCE_PLAN_LIST: (state, attendancePlanList) => {
      state.attendancePlanList = attendancePlanList;
    },
    SET_SUBJECT_LIST: (state, subjectList) => {
      state.subjectList = subjectList;
    },
    SET_TEACHER_LIST: (state, teacherList) => {
      state.teacherList = teacherList;
    }
  },
  actions: {
    async changeAddPlan({ commit }, addPlan) {
      commit('SET_ADD_PLAN_FLAG', addPlan);
    },
    async changePlanIsLoading({ commit }, planIsLoading) {
      commit('SET_PLAN_IS_LOADING', planIsLoading);
    },
    getSubjectList({ commit }) {
      return new Promise((resolve, reject) => {
        getSubjectList().then(res => {
          const subjectList = [];
          for (let i = 0; i < res.length; i++) {
            const element = res[i];
            subjectList.push({
              id: element.tech_id,
              value: `${element.tech_id}-${element.tech_name}`,
              name: element.tech_name
            });
          }
          commit('SET_SUBJECT_LIST', subjectList);
          resolve();
        });
      });
    },
    getTacherList({ commit }, requestParams) {
      return new Promise((resolve, reject) => {
        getUserList(requestParams).then(res => {
          const teacherList = [];
          for (let i = 0; i < res.length; i++) {
            const element = res[i];
            if (element.thirdPartyId) {
              teacherList.push({
                id: element.thirdPartyId,
                value: `${element.thirdPartyId}-${element.mobile}-${element.realName}`,
                realName: element.realName
              });
            }
          }
          commit('SET_TEACHER_LIST', teacherList);
          resolve();
        });
      });
    },
    getData({ commit }, requestParams) {
      commit('SET_PLAN_IS_LOADING', true);
      this.dispatch('ai/plan/changePlanIsLoading', true);
      return new Promise((resolve, reject) => {
        getPlanCourseList(requestParams)
          .then(res => {
            if (res.length > 0) {
              commit('SET_PLAN_MAIN_CONTENT_LIST', res);
            } else {
              commit('SET_PLAN_MAIN_CONTENT_LIST', []);
            }
            this.dispatch('ai/plan/changePlanIsLoading', false);
            resolve();
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getAttendPlanList({ commit }, requestParams) {
      this.dispatch('ai/plan/changePlanIsLoading', true);
      getPlanList(requestParams).then(res => {
        commit('SET_ATTENDANCE_PLAN_LIST', res);
        this.dispatch('ai/plan/changePlanIsLoading', false);
      });
    },
    addPlan(_, requestParams) {
      return new Promise((resolve, reject) => {
        addPlan(requestParams)
          .then(res => {
            console.log(res);
            if (res) {
              resolve(true);
            } else {
              resolve(false);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    updatePlan(_, requestParams) {
      return new Promise((resolve, reject) => {
        updatePlan(requestParams)
          .then(res => {
            console.log(res);
            if (res) {
              resolve(true);
            } else {
              resolve(false);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    deletePlan(_, requestParams) {
      return new Promise((resolve, reject) => {
        deletePlan(requestParams)
          .then(res => {
            console.log(res);
            if (res) {
              resolve(true);
            } else {
              resolve(false);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    addCourse(_, requestParams) {
      return new Promise((resolve, reject) => {
        addCourse(requestParams)
          .then(res => {
            console.log(res);
            if (res) {
              resolve(true);
            } else {
              resolve(false);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  }
};

export default plan;
